import { render, staticRenderFns } from "./CasesSection.vue?vue&type=template&id=107afd42&"
import script from "./CasesSection.vue?vue&type=script&lang=js&"
export * from "./CasesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports